import '../scss/style.scss';

const ATTRIBUTION_KEY = 'reqst_attribution';
const ATTRIBUTION_TTL = 90 * 24 * 60 * 60 * 1000; // Google Ads click lookback.
// gbraid/wbraid are what Google sends in place of gclid on iOS and app traffic.
const ATTRIBUTION_PARAMS = [ 'gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign' ];
const CONSENT_COOKIE = 'reqst_cookieconsent';

function consentState() {
	const found = document.cookie
		.split( '; ' )
		.find( ( c ) => c.startsWith( CONSENT_COOKIE + '=' ) );

	if ( ! found ) {
		return null;
	}

	try {
		return JSON.parse( decodeURIComponent( found.split( '=' ).slice( 1 ).join( '=' ) ) );
	} catch ( e ) {
		return null;
	}
}

function attributionFromUrl() {
	const params = new URLSearchParams( window.location.search );
	const record = {};

	ATTRIBUTION_PARAMS.forEach( ( key ) => {
		const value = params.get( key );

		if ( value ) {
			record[ key ] = value;
		}
	} );

	return record;
}

function storedAttribution() {
	try {
		const stored = JSON.parse( window.localStorage.getItem( ATTRIBUTION_KEY ) );

		return stored && stored.value && Date.now() < stored.expiryDate ? stored.value : {};
	} catch ( e ) {
		return {};
	}
}

function persistAttribution( record ) {
	try {
		window.localStorage.setItem( ATTRIBUTION_KEY, JSON.stringify( {
			value: record,
			expiryDate: Date.now() + ATTRIBUTION_TTL,
		} ) );
	} catch ( e ) {
		// Private browsing or a full quota: attribution is a bonus, not a blocker.
	}
}

/**
 * Carry the attribution forward through internal links instead of storing it.
 * A query parameter is not local storage, so it needs no consent, and the
 * visitor keeps the click that paid for the visit while the banner is still
 * unanswered. Anchors and external links are left alone.
 */
function propagateAttribution( record ) {
	document.querySelectorAll( 'a[href]' ).forEach( ( link ) => {
		const raw = link.getAttribute( 'href' );

		if ( ! raw || raw.startsWith( '#' ) || /^(mailto|tel|javascript):/i.test( raw ) ) {
			return;
		}

		let url;

		try {
			url = new URL( link.href, window.location.href );
		} catch ( e ) {
			return;
		}

		if ( url.origin !== window.location.origin ) {
			return;
		}

		let touched = false;

		Object.entries( record ).forEach( ( [ key, value ] ) => {
			if ( ! url.searchParams.has( key ) ) {
				url.searchParams.set( key, value );
				touched = true;
			}
		} );

		if ( touched ) {
			link.href = url.toString();
		}
	} );
}

/**
 * Undo the propagation: after an explicit refusal the click id has no business
 * still travelling from link to link, even unstored.
 */
function stripAttribution() {
	document.querySelectorAll( 'a[href]' ).forEach( ( link ) => {
		let url;

		try {
			url = new URL( link.href, window.location.href );
		} catch ( e ) {
			return;
		}

		if ( url.origin !== window.location.origin ) {
			return;
		}

		let touched = false;

		ATTRIBUTION_PARAMS.forEach( ( key ) => {
			if ( url.searchParams.has( key ) ) {
				url.searchParams.delete( key );
				touched = true;
			}
		} );

		if ( touched ) {
			link.href = url.toString();
		}
	} );
}

function initAttribution() {
	const stored = storedAttribution();
	const record = Object.keys( stored ).length ? stored : attributionFromUrl();

	if ( ! Object.keys( record ).length ) {
		return;
	}

	const consent = consentState();

	if ( consent && 'granted' === consent.ad_storage ) {
		persistAttribution( record );
		return;
	}

	// Choice still pending: keep it alive across pages without writing anything.
	// An explicit refusal stops the propagation instead.
	if ( ! consent ) {
		propagateAttribution( record );
	}

	// React to the answer without waiting for a page load.
	window.addEventListener( 'reqst:consent', ( event ) => {
		if ( ! event.detail ) {
			return;
		}

		if ( 'granted' === event.detail.ad_storage ) {
			persistAttribution( record );
		} else {
			stripAttribution();
		}
	} );
}

document.addEventListener('DOMContentLoaded', () => {
	initAttribution();

	// Activate sticky header after the hero (first block) scrolls out of view
	const stickyHeader = document.querySelector('.wp-block-template-part.is-sticky');
	if ( stickyHeader ) {
		const hero = document.querySelector( '.wp-block-reqst-hero-homepage, .wp-block-reqst-hero, .entry-content > *:first-child' );
		if ( hero ) {
			const observer = new IntersectionObserver( ( [ entry ] ) => {
				stickyHeader.classList.toggle( 'is-sticky-active', ! entry.isIntersecting );
			}, { threshold: 0 } );
			observer.observe( hero );
		}
	}
	const animated = [
		'.wp-block-reqst-about',
		'.wp-block-reqst-hero-homepage',
		'.wp-block-reqst-text-image',
		'.wp-block-reqst-fees',
		'.wp-block-reqst-content-list',
		'.wp-block-reqst-image-sections',
		'.wp-block-reqst-accordeon',
		'.wp-block-reqst-carousel',
		'.wp-block-reqst-reviews',
		'.wp-block-reqst-cta-banner',
	]
	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if (entry.isIntersecting) {
				entry.target.classList.add( 'intersecting' );
			}
		} );
	}, { threshold: 0 } );
	document.querySelectorAll(animated.join(', ')).forEach((block) => {
		block.classList.add('animated');
		observer.observe(block);
	});

	// Same idea for the `.animated` convention: add `animating` once the element
	// enters the viewport to play its entrance transition, then stop observing.
	// The bottom rootMargin keeps entrances from firing while an element merely
	// peeks at the fold — on mobile the toolbar makes the real viewport differ
	// from CSS 100vh, so the next section otherwise animated on load.
	const animationObserver = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if ( entry.isIntersecting ) {
				entry.target.classList.add( 'animating' );
				animationObserver.unobserve( entry.target );
			}
		} );
	}, { threshold: 0, rootMargin: '0px 0px -15% 0px' } );
	document.querySelectorAll( '.animated' ).forEach( ( el ) => {
		animationObserver.observe( el );
	} );

	// Start the marquee ~1s after load: Safari composites the track from the
	// pre-font/pre-image layout and never refreshes it if it starts earlier.
	const startProblemsMarquee = () => {
		if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			return;
		}
		document.querySelectorAll( '.wp-block-reqst-problems .problems-track' )
			.forEach( ( track ) => track.classList.add( 'is-animating' ) );
	};
	if ( document.readyState === 'complete' ) {
		setTimeout( startProblemsMarquee, 1000 );
	} else {
		window.addEventListener( 'load', () => setTimeout( startProblemsMarquee, 1000 ) );
	}
});
